// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a0688808","703":"feb2fb36","787":"9320d41d"}[chunkId] + ".chunk.js";
};